import { VcenterView } from '../view/VcenterView';
import { templateVcenter } from '../view/template';
import { VcenterRepository } from '../repository/VcenterRepository';
import { BaseWebComponentController } from '../../../../framework/BaseWebComponentController';
import { VcenterWebComponent } from '..';
import { Company } from '../../../../tagsManager/types/tag-data';
import { NewIntegration } from '../../../saveIntegration/types';
import { IntegrationTypes } from '../../../integrationsMarketplaceGridInstalled/types';
import { BaseIntegrationController } from '../../BaseIntegrationController';
import { SaveIntegrationWebComponent } from '../../../saveIntegration';

export class VcenterController extends BaseIntegrationController {
  public component: VcenterWebComponent;
  public dataRepository: VcenterRepository;
  public view: VcenterView;
  public createButton: any;
  public viewConstructor: typeof VcenterView;
  public dataRepositoryConstructor: typeof VcenterRepository;
  public company: Company;
  private integrationId: string;

  constructor(component: VcenterWebComponent | SaveIntegrationWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: VcenterView,
      viewTemplate: templateVcenter,
      dataRepositoryConstructor: VcenterRepository,
    });

    this.createButton = this.dependencies.createButton;
  }

  public createIntegrationRecord($vcenter): NewIntegration {
    const record: NewIntegration = {
      companyId: $vcenter.getCompanyId(),
      name: $vcenter.getNameValue(),
      type: IntegrationTypes.Vcenter,
      specifics: {
        hostname: $vcenter.getHostnameValue(),
        port: $vcenter.getPortValue(),
        username: $vcenter.getUsernameValue(),
        password: $vcenter.getPasswordValue(),
        retryAuthentication: $vcenter.getCustomizeSyncCheckboxValue(),
        retryAuthenticationMaxAttempts: $vcenter.getRetryAuthenticationMaxAttemptsValue(),
        retryAuthenticationTimeToWait: $vcenter.getRetryAuthenticationTimeToWaitValue(),
        verifyTLSCertificate: $vcenter.getVerifyTLSCertificateValue(),
        viewType: $vcenter.getViewTypeValue(),
      },
    };

    return record;
  }

  async getDataForView(): Promise<any> {
    return {
      integrationId: this.integrationId,
      company: this.company,
    };
  }

  public setCompany(value: Company) {
    this.company = value;
  }

  public setIntegrationId(value: string) {
    this.integrationId = value;
  }
}
